import { Box, Typography } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import IncButton from 'components/inc-button/inc-button.component';
import { CheckoutH3 } from 'pages/checkout/checkout.styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  selectCustomerInfo,
  selectIsGuestVerified,
} from 'redux/cart/cart.selectors';
import { selectGuestCheckoutVerificationDeliveryMethod } from 'redux/config/config.selectors';
import CheckoutSectionPreview from '../../checkout-section/checkout-section-preview/checkout-section-preview.component';

const CheckoutContactInfoSectionPreview = ({
  openModal,
  maskedRecipient,
  expirationMinutes,
  isGuestCheckoutVerificationEnabled,
  sendCode,
}) => {
  const { t } = useTranslation();
  const customerInfo = useSelector(selectCustomerInfo);
  const isGuestVerified = useSelector(selectIsGuestVerified);
  const deliveryMethod = useSelector(
    selectGuestCheckoutVerificationDeliveryMethod,
  );

  const { firstName, lastName, phoneNumber, email } = customerInfo;

  const onVerifyButtonClick = () => {
    if (maskedRecipient) openModal();
    else sendCode(customerInfo);
  };

  return (
    <CheckoutSectionPreview>
      <CheckoutH3 data-testid="CheckoutContactInfoSectionPreview.CheckoutH3.Name">
        {firstName} {lastName}
      </CheckoutH3>
      <Box display="flex" flexWrap="wrap" alignItems="center">
        <Box mr={1} display="flex" alignItems="center">
          <PhoneIcon color="primary" fontSize="small" />
          <Box
            ml="4px"
            data-testid="CheckoutContactInfoSectionPreview.Box.Phone"
          >
            {phoneNumber}
          </Box>
        </Box>
        <Box mr={1} display="flex" alignItems="center">
          <EmailIcon color="primary" fontSize="small" />
          <Box
            ml="4px"
            data-testid="CheckoutContactInfoSectionPreview.Box.Email"
          >
            {email}
          </Box>
        </Box>
      </Box>
      {isGuestCheckoutVerificationEnabled && !isGuestVerified && (
        <Box mt={1}>
          {maskedRecipient && (
            <Typography
              variant="body2"
              mb={1}
              data-testid="CheckoutContactInfoSectionPreview.Typography.SentCode"
            >
              {t('checkout.guestVerification.previewBody', {
                recipient: maskedRecipient,
                minutes: expirationMinutes,
              })}
            </Typography>
          )}
          <IncButton
            fullWidth
            onClick={onVerifyButtonClick}
            data-testid="CheckoutContactInfoSectionPreview.IncButton.Verify"
          >
            {deliveryMethod === 'SMS'
              ? t('guest.label.verifyPhone')
              : t('guest.label.verifyEmail')}
          </IncButton>
        </Box>
      )}
    </CheckoutSectionPreview>
  );
};

export default CheckoutContactInfoSectionPreview;
